// Basic
import PropTypes from 'prop-types';
// Libs
import { QRCodeSVG } from 'qrcode.react';
// Components
import { Modal, ModalBody, ModalContent, ModalHeader, ModalTitle } from '../../../../../../common-utils/components/ui/modal';
import FooterForm from '../../../../../../common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '../../../../../../common-utils/components/renders/entity/Entity';
import PersoPDFFile from '../pdf/PersoPDFFile';
// Store
import useMerchantAccountStore from '@/app/store/modules/merchantAccount';
// Lang
import { nsCustomization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.customization
 * @returns {JSX} ModalQrCode
 */
function ModalQrCode({ isOpen, setIsOpen, customization }) {
    // Store
    const merchantAccountDetails = useMerchantAccountStore((state) => state.merchantAccountDetails);
    const merchantAccountLabel = merchantAccountDetails?.label || '';

    // Functions
    const onClose = () => {
        setIsOpen(false);
    };

    return <Modal open={isOpen} onOpenChange={onClose}>
        <ModalContent className='max-w-md'>
            <ModalHeader>
                <ModalTitle className='text-lg font-semibold'>
                    <Entity entity='modal.qr_code.title' namespace={nsCustomization} />
                </ModalTitle>
            </ModalHeader>
            <ModalBody className='space-y-6'>
                <div className='flex flex-col items-center space-y-4'>
                    {/* QR Code */}
                    <div className='p-4 bg-white border border-gray-200 rounded-lg shadow-sm'>
                        <QRCodeSVG
                            id='qr-code-svg'
                            value={customization?.packageCode || ''}
                            size={200}
                            level='M'
                            includeMargin={true}
                        />
                    </div>

                    {/* QR Code description */}
                    <div className='text-center'>
                        <Entity
                            entity='modal.qr_code.description'
                            namespace={nsCustomization}
                            className='text-sm text-gray-700'
                        />
                    </div>

                    {/* Download component */}
                    <PersoPDFFile
                        customization={customization}
                        merchantAccountLabel={merchantAccountLabel}
                        qrCodeElementId='qr-code-svg'
                    />
                </div>
            </ModalBody>
            <FooterForm showSubmitButton={false} />
        </ModalContent>
    </Modal>;
}

ModalQrCode.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    customization: PropTypes.object.isRequired
};

export default ModalQrCode;